import {AbstractControl, type ValidationErrors} from '@angular/forms';

export function HttpsOnlyValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;
  if (!value) return null;
  return value.startsWith('https://') ? null : {'https-only': true};
}

export function HttpsOnlyValidatorMessage(): string {
  return 'URL must start with "https://".';
}
